var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBulk = function SvgBulk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    x: 3,
    y: 3,
    fill: "#E2FFEA",
    rx: 27
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    x: 3,
    y: 3,
    stroke: "#F4FFF7",
    strokeWidth: 6,
    rx: 27
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#51C394",
    d: "M41.334 27a11.334 11.334 0 1 0-22.667 0 11.334 11.334 0 0 0 22.667 0m-9.372 7.163c-.888 1.886-1.719 2.17-1.962 2.17s-1.073-.284-1.96-2.17c-.41-.871-.755-1.943-.997-3.163h5.915c-.241 1.22-.587 2.293-.996 3.163M26.667 27q.002-1.037.09-2h6.486c.122 1.33.122 2.67 0 4h-6.485a22 22 0 0 1-.09-2m6.76 8.684c.695-1.24 1.24-2.848 1.566-4.684h3.442a9.37 9.37 0 0 1-5.008 4.684M35.251 29a24 24 0 0 0 0-4h3.867a9.4 9.4 0 0 1 0 4zm-14.37 0a9.4 9.4 0 0 1 0-4h3.867a24 24 0 0 0 0 4zm4.126 2c.327 1.836.87 3.445 1.566 4.684A9.37 9.37 0 0 1 21.566 31zm7.95-8h-5.914c.242-1.22.587-2.293.996-3.163.888-1.886 1.719-2.17 1.961-2.17.243 0 1.074.284 1.962 2.17.41.871.755 1.943.996 3.163m5.477 0h-3.443c-.326-1.836-.87-3.445-1.565-4.684A9.37 9.37 0 0 1 38.435 23M25.01 23h-3.443a9.37 9.37 0 0 1 5.008-4.684c-.695 1.24-1.24 2.848-1.565 4.684m-5.675 11.333h.337a12.7 12.7 0 0 0 1.765 2h-1.342l-1.11 4h22.034l-1.11-4h-1.343a12.7 12.7 0 0 0 1.765-2h.337a1 1 0 0 1 .964.734l1.667 6a1 1 0 0 1-.964 1.266H17.667a1 1 0 0 1-.964-1.266l1.667-6a1 1 0 0 1 .964-.734"
  })));
};
export default SvgBulk;